/**
 * Builds lodash get/set path strings for a placeholder row and its keyed field.
 */
export const placeholderManagementPath = (index: number, keyname: string) => {
  return {
    COMMONPATH: `placeholderManagement[${index}][${keyname}]`,
    GET_CURRENT_INDEX_OBJECT: `placeholderManagement[${index}]`,
  };
};

/**
 * Builds path strings for a dynamic column on a placeholder row.
 */
export const dynamicColumnPath = (index: number, dyIndex: number, keyname: string) => {
  return {
    DYNAMIC_COLUMN_PATH: `placeholderManagement[${index}].dynamicColumn[${dyIndex}]`,
    DYNAMIC_COLUMN_PATH_KEYNAME: `placeholderManagement[${index}].dynamicColumn[${dyIndex}][${keyname}]`,
  };
};

/**
 * Builds the path to a placeholder row's whole Multi Custom Attribute
 * selections array (replaced in one shot per multi-select change, unlike
 * dynamicColumn's per-keyname path).
 */
export const multiDynamicColumnPath = (index: number) => {
  return {
    MULTI_DYNAMIC_COLUMN_PATH: `placeholderManagement[${index}].multiCustomAttribute`,
  };
};

/**
 * Builds the path to a product row's whole Multi Custom Attribute
 * selections array, nested under a placeholder row.
 */
export const productListMultiDynamicColumnPath = (index: number, chIndex: number) => {
  return {
    MULTI_DYNAMIC_COLUMN_PATH: `placeholderManagement[${index}].productList[${chIndex}].multiCustomAttribute`,
  };
};

/**
 * Builds path strings for a product row nested under a placeholder row.
 */
export const productListPath = (index: number, chIndex: number, keyname: string) => {
  return {
    COMMONPATH: `placeholderManagement[${index}].productList[${chIndex}][${keyname}]`,
  };
};

/**
 * Builds path strings for a dynamic column on a nested product row.
 */
export const productListDynamicPath = (index: number, chIndex: number, dyIndex: number, keyname: string) => {
  return {
    DYNAMIC_COLUMN_PATH: `placeholderManagement[${index}].productList[${chIndex}].dynamicColumn[${dyIndex}]`,
    DYNAMIC_COLUMN_PATH_KEYNAME: `placeholderManagement[${index}].productList[${chIndex}].dynamicColumn[${dyIndex}][${keyname}]`,
    GET_DYNAMIC_COLUMN_PATH: `placeholderManagement[${index}].productList[${chIndex}].dynamicColumn`,
  };
};
